<div class="flex flex-column align-items-center justify-content-center h-screen">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    <p class="mt-3">Logging out...</p>
</div>